<script>
import PhotoSwipe from 'photoswipe/dist/photoswipe.esm.js';
import PhotoSwipeLightbox from 'photoswipe/dist/photoswipe-lightbox.esm.js';

export default {
	name: 'gallery',

	data() {
		return {
			lightbox: null
		};
	},


	mounted() {
		this.setSizes();

		if (!this.lightbox) {
			this.lightbox = new PhotoSwipeLightbox({
				gallery: this.$refs.gallery,
				children: 'a',
				pswpModule: PhotoSwipe
			});
			this.lightbox.init();
		}
	},

	methods: {
		setSizes() {
			let items = this.$refs.gallery.getElementsByTagName('a');
			let v_width = window.innerWidth;
			let v_height = window.innerHeight;

			for (let i = 0; i < items.length; i++) {
				let image = items[i].getElementsByTagName('img')[0];
				let width = parseInt(image.getAttribute('width'));
				let height = parseInt(image.getAttribute('height'));
				let ratio  = height / width;

				if (width > height) { // Landscape
					width = v_width * 0.9;
					height = width * ratio;

				} else { // Portrait
					height = v_height * 0.9;
					width = height * ratio;
				}


				items[i].setAttribute('data-pswp-width', width);
				items[i].setAttribute('data-pswp-height', height);
			}
		}
	},

	beforeDestroy() {
		if (this.lightbox) {
			this.lightbox.destroy();
			this.lightbox = null;
		}
	}
};

</script>